import clsx from 'clsx';
import FullScreen from 'components/FullScreen';
import { APP_MODULES } from 'constants/appModules';
import { getPathParamName } from 'helpers/PathHelper';
import { FC } from 'react';
import { useIntl } from 'react-intl';
import { generatePath, NavLink } from 'react-router-dom';
import { SubModule } from 'types/subModule';

import styles from './SubModuleTabs.module.scss';

export interface Props {
  tabModule: APP_MODULES;
  subModules: SubModule[];
  pathParams: { [pathParam: string]: string | undefined };
  setSidebarOpen: (openSiderBar: boolean) => void;
}

const SubModuleTabs: FC<Props> = ({ tabModule, subModules, pathParams, setSidebarOpen }) => {
  const intl = useIntl();

  return (
    <div className={styles.container}>
      <div className={styles.tabContainer}>
        {subModules.map(({ name, displayedName: nameTranslationId, path }) => {
          const pathParamName = getPathParamName(path);
          const pathParam = pathParamName ? pathParams[pathParamName] : undefined;
          const basicDisabledTabCondition = !!(pathParamName && !pathParam);
          const isSubModuleDisabled = basicDisabledTabCondition;
          const generatedPath = isSubModuleDisabled
            ? ''
            : pathParam
            ? generatePath(path, { [pathParamName]: pathParam })
            : path;

          const displayedTabName = intl.formatMessage({ id: nameTranslationId });

          return (
            <NavLink
              exact
              isActive={(match, { pathname, search }) => {
                if (!match) return false;

                if (generatedPath.includes('?') && pathname + search === generatedPath) return true;

                if (!generatedPath.includes('?') && pathname === generatedPath) return true;

                return false;
              }}
              to={generatedPath}
              key={path}
              className={clsx(styles.link, isSubModuleDisabled && styles.disableLink)}
              activeClassName={styles.activeLink}
            >
              {displayedTabName}
            </NavLink>
          );
        })}
      </div>
      {tabModule !== APP_MODULES.LESSONS_LEARNT && (
        <FullScreen data-testid="FS" isOnlyIcon={false} />
      )}
    </div>
  );
};

export default SubModuleTabs;
